import enLang from './locales/en_US.json';
import esLang from './locales/es_ES.json';

const AppLocale = {
  en: enLang,
  es: esLang,
};

export default AppLocale;
